/**
 * Unknown route. Renders inside the shell so the user keeps their navigation
 * and can simply carry on, rather than hitting a dead end.
 *
 * f9.2: the way out targets `/dashboard` only when the server permitted it;
 * otherwise the computed landing, so the recovery link is never itself a dead
 * end.
 */

import { Link } from 'react-router-dom';
import { Compass } from 'lucide-react';

import { recoveryPathFor } from '@/navigation/landing';
import { DEFAULT_ROUTE } from '@/navigation/navigation';
import { useSessionScope } from '@/session/SessionScopeContext';

export function NotFound() {
  const { session } = useSessionScope();
  const recovery = recoveryPathFor(session?.navigation ?? []);

  return (
    <>
      <div className="page-head">
        <div>
          <h1 className="page-title">Page not found</h1>
          <div className="page-sub">That address does not match anything in Atlas.</div>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <div className="empty">
            <div className="e-icon">
              <Compass aria-hidden="true" />
            </div>
            <h3>Nothing here</h3>
            <p>The link may be out of date, or it may have been typed incorrectly.</p>
            <p className="empty-actions">
              <Link className="btn btn-primary" to={recovery}>
                {recovery === DEFAULT_ROUTE ? 'Back to the dashboard' : 'Go to your start page'}
              </Link>
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
